import { css } from 'styled-components';

// Transition
export function transition(timing = 0.3) {
  return `
      -webkit-transition: all ${timing}s cubic-bezier(0.215, 0.61, 0.355, 1);
      -moz-transition: all ${timing}s cubic-bezier(0.215, 0.61, 0.355, 1);
      -ms-transition: all ${timing}s cubic-bezier(0.215, 0.61, 0.355, 1);
      -o-transition: all ${timing}s cubic-bezier(0.215, 0.61, 0.355, 1);
      transition: all ${timing}s cubic-bezier(0.215, 0.61, 0.355, 1);
  `;
}

// Border Radius
export function borderRadius(radius = '0') {
  return `
      -webkit-border-radius: ${radius};
      -moz-border-radius: ${radius};
      -ms-transition: ${radius};
      -o-border-radius: ${radius};
      border-radius: ${radius};
  `;
}

// Box Shadow
export function boxShadow(shadow = 'none') {
  return `
      -webkit-box-shadow: ${shadow};
      -moz-box-shadow: ${shadow};
      box-shadow: ${shadow};
  `;
}

export function animateBackground(args) {
  return `
  background: linear-gradient(${args});
  background-size: 400% 400%;

  -webkit-animation: AnimationName 30s ease infinite;
  -moz-animation: AnimationName 30s ease infinite;
  animation: AnimationName 30s ease infinite;

  @-webkit-keyframes AnimationName {
    0% {
      background-position: 90% 0%;
    }
    50% {
      background-position: 11% 100%;
    }
    100% {
      background-position: 90% 0%;
    }
  }
  @-moz-keyframes AnimationName {
    0% {
      background-position: 90% 0%;
    }
    50% {
      background-position: 11% 100%;
    }
    100% {
      background-position: 90% 0%;
    }
  }
  @keyframes AnimationName {
    0% {
      background-position: 90% 0%;
    }
    50% {
      background-position: 11% 100%;
    }
    100% {
      background-position: 90% 0%;
    }
  }`;
}

export const fancyAnimatedBackground = css`
  @property --angle {
    syntax: '<angle>';
    inherits: false;
    initial-value: 102deg;
  }
  @property --location-one {
    syntax: '<percentage>';
    inherits: false;
    initial-value: -47.36%;
  }
  @property --color-one {
    syntax: '<color>';
    inherits: false;
    initial-value: #d0ddfa;
  }
  @property --location-two {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 119.39%;
  }
  @property --color-two {
    syntax: '<color>';
    inherits: false;
    initial-value: rgba(239, 244, 253, 0.2);
  }
  background: ${({ theme }) =>
    theme.name === 'atsDark'
      ? theme.palette.dark[3]
      : css`
      linear-gradient(
        var(--angle),
        var(--color-one) var(--location-one),
        var(--color-two) var(--location-two)
      ),
      #fff`};
  animation: ${({ theme }) =>
    theme.name === 'atsDark' ? 'none' : `loop-gradient 5s ease infinite`};
  &::before {
    content: '';
    height: 30px;
    width: 30px;
    display: ${({ theme }) => (theme.name === 'atsDark' ? 'none' : 'block')};
    position: absolute;
    filter: blur(35.5px);
    background-color: rgba(255, 220, 104, 1);
    right: 10px;
    top: calc(100% - 20px);
    border-radius: 15px;
    animation: move-circle 5s ease 0ms infinite;
  }
  @keyframes loop-gradient {
    // 1.2s - 36%
    // background: linear-gradient(102deg, #D0DDFA -47.36%, rgba(239, 244, 253, 0.20) 119.39%), #FFF;
    // 0.5s - 16%
    // background: linear-gradient(95deg, rgba(235, 231, 249, 0.20) -0.69%, #DCD3F3 123.01%), #FFF;
    // 0.8s - 25%
    // background: linear-gradient(94deg, rgba(239, 244, 253, 0.20) -0.59%, #DCD3F3 124.8%), #FFF;
    // 0.8s - 25%
    // background: linear-gradient(95deg, rgba(235, 231, 249, 0.20) -0.69%, #DCD3F3 123.01%), #FFF;
    // 1.2s - 36%
    // background: linear-gradient(102deg, #D0DDFA -47.36%, rgba(239, 244, 253, 0.20) 119.39%), #FFF;

    0% {
      --angle: 102deg;
      --color-one: #d0ddfa;
      --location-one: -47.36%;
      --color-two: rgba(239, 244, 253, 0.2);
      --location-two: 119.39%;
    }
    35% {
      --angle: 95deg;
      --color-one: rgba(235, 231, 249, 0.2);
      --location-one: -0.69%;
      --color-two: #dcd3f3;
      --location-two: 123.01%;
    }
    50% {
      --angle: 94deg;
      --color-one: rgba(239, 244, 253, 0.2);
      --location-one: -0.59%;
      --color-two: #dcd3f3;
      --location-two: 124.8%;
    }
    75% {
      --angle: 95deg;
      --color-one: rgba(235, 231, 249, 0.2);
      --location-one: -0.69%;
      --color-two: #dcd3f3;
      --location-two: 123.01%;
    }
    100% {
      --angle: 102deg;
      --color-one: #d0ddfa;
      --location-one: -47.36%;
      --color-two: rgba(239, 244, 253, 0.2);
      --location-two: 119.39%;
    }
  }
  @keyframes move-circle {
    0% {
      right: 10px;
      top: calc(100% - 20px);
    }
    35% {
      right: calc(100% - 80px);
      top: calc(100% - 20px);
    }
    50% {
      right: calc(100% - 40px);
      top: calc(100% - 60px);
    }
    75% {
      right: calc(100% - 80px);
      top: calc(100% - 20px);
    }
    100% {
      right: 10px;
      top: calc(100% - 20px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
    &::before {
      animation: none !important;
    }
  }
`;
